import { render } from "./ArticleBodyText.vue?vue&type=template&id=04ca08e8&scoped=true"
import script from "./ArticleBodyText.vue?vue&type=script&lang=js"
export * from "./ArticleBodyText.vue?vue&type=script&lang=js"

import "./ArticleBodyText.vue?vue&type=style&index=0&id=04ca08e8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ca08e8"]])

export default __exports__